import Vue from 'vue'
import { baseUrl } from './config'

// tel phone hide middle four number
const telNumberFormat = Vue.filter('telNumberFormat', function (num) {
  if (num) {
    var str = num.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    return str
  }
  return num
})

// set base url to url
const resetURL = Vue.filter('resetURL', function (url) {
  if (url) {
    return `${baseUrl.apiUrl}${url}`
  } else {
    return '/static/images/avatar.png'
  }
})

const formatTimeLong = Vue.filter('formatTimeLong', function (timeLong, timeType) {
  timeType = timeType || 'minutes'
  let days = Math.floor(timeLong / (24 * 60 * 60 * 1000))
  let hours = Math.floor((timeLong % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
  let minutes = Math.floor((timeLong % (60 * 60 * 1000)) / (60 * 1000))
  let seconds = Math.floor((timeLong % (60 * 1000)) / 1000)
  var constr = ``
  if (days) {
    constr += `${days}天`
  }
  if (hours) {
    constr += `${hours}小时`
  }
  if (minutes) {
    constr += `${minutes}分`
  }
  if (timeType === 'seconds' && seconds) {
    constr += `${seconds}秒`
  }
  return constr.length > 0 ? constr : '0分'
})

const formatDuration = Vue.filter('formatDuration', function (timeLong) {
  let add0 = (m) => {
    if (+m < 10) {
      m = '0' + m
    } else {
      return m
    }
    return m
  }
  let hours = Math.floor(timeLong / (60 * 60 * 1000))
  let minutes = Math.floor((timeLong - hours * (60 * 60 * 1000)) / 60)
  let seconds = Math.floor(timeLong % 60)
  let duration = add0(hours) + ':' + add0(minutes) + ':' + add0(seconds)
  return duration
})

const translate = Vue.filter('translate', function (str, $gettext) {
  if (!$gettext) {
    $gettext = t => t
  }
  return $gettext(str)
})

const version = Vue.filter('version', function (version) {
  if (version) {
    let firstVersionNum = version.split('-')[0]
    return firstVersionNum
  }
})

export {
  telNumberFormat,
  resetURL,
  formatTimeLong,
  formatDuration,
  translate,
  version
}




// WEBPACK FOOTER //
// ./src/filter.js